<div class="about-page">
  <header class="about-page__head">
    <h1>À propos</h1>
  </header>

  <div class="about-page__state" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Chargement des informations…</p>
  </div>

  <div class="about-page__state about-page__state--error" *ngIf="!loading && errorMessage && !info">
    <p>{{ errorMessage }}</p>
    <button type="button" mat-stroked-button color="primary" (click)="load()">Réessayer</button>
  </div>

  <ng-container *ngIf="!loading && info">
    <section class="about-card about-card--header">
      <img
        class="about-card__logo"
        [src]="logoUrl"
        [alt]="companyName"
        (error)="onLogoError($event)" />
      <h2>{{ companyName }}</h2>
      <p class="about-card__version">Version 1.0.0</p>
    </section>

    <article class="about-section" *ngFor="let section of sections">
      <header class="about-section__head" *ngIf="section.title">
        <span class="about-section__bar" aria-hidden="true"></span>
        <h3>{{ section.title }}</h3>
      </header>
      <div class="about-section__body" *ngIf="section.content || section.items.length">
        <p *ngIf="section.content">{{ section.content }}</p>
        <ul *ngIf="section.items.length">
          <li *ngFor="let item of section.items">{{ item }}</li>
        </ul>
      </div>
    </article>

    <section class="about-card" *ngIf="hasContact">
      <h3>Contact</h3>
      <a class="about-contact" *ngIf="phone" [href]="'tel:' + phone">
        <span class="about-contact__icon">
          <mat-icon>phone</mat-icon>
        </span>
        <span>{{ phone }}</span>
        <mat-icon class="about-contact__chevron">chevron_right</mat-icon>
      </a>
      <a class="about-contact" *ngIf="email" [href]="'mailto:' + email">
        <span class="about-contact__icon">
          <mat-icon>mail_outline</mat-icon>
        </span>
        <span>{{ email }}</span>
        <mat-icon class="about-contact__chevron">chevron_right</mat-icon>
      </a>
    </section>

    <a
      class="about-card about-card--link"
      *ngIf="usageConditionsUrl"
      [href]="usageConditionsUrl"
      target="_blank"
      rel="noopener noreferrer">
      <mat-icon>description</mat-icon>
      <span>Conditions d’utilisation &amp; confidentialité</span>
      <mat-icon>open_in_new</mat-icon>
    </a>

    <section class="about-social" *ngIf="socialLinks.length">
      <p>Suivez-nous</p>
      <div class="about-social__row">
        <a
          *ngFor="let link of socialLinks"
          class="about-social__btn"
          [href]="link.href"
          [attr.aria-label]="link.label"
          [attr.target]="link.kind === 'email' ? null : '_blank'"
          [attr.rel]="link.kind === 'email' ? null : 'noopener noreferrer'">
          <svg *ngIf="link.kind === 'email'" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
          <svg *ngIf="link.kind === 'facebook'" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07C2 17.1 5.66 21.24 10.44 22v-7.02H7.9v-2.91h2.54V9.84c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.91h-2.34V22C18.34 21.24 22 17.1 22 12.07z"/>
          </svg>
          <svg *ngIf="link.kind === 'linkedin'" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M6.94 6.5A1.94 1.94 0 1 1 5 4.56 1.94 1.94 0 0 1 6.94 6.5zM7 8.89H3.89V20H7zm13 6.36c0-3.14-1.68-4.6-3.92-4.6a3.39 3.39 0 0 0-3.04 1.54h-.08V8.89H9.89V20h3.08v-5.54c0-1.46.28-2.87 2.08-2.87 1.78 0 1.8 1.66 1.8 2.96V20H20z"/>
          </svg>
          <svg *ngIf="link.kind === 'twitter'" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M18.24 2H21l-6.51 7.44L22 22h-6.17l-4.82-6.3L5.35 22H2.58l6.97-7.97L2 2h6.32l4.36 5.77L18.24 2zm-1.08 18.04h1.7L6.92 3.86H5.1l12.06 16.18z"/>
          </svg>
          <svg *ngIf="link.kind === 'whatsapp'" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M12.04 2C6.58 2 2.15 6.43 2.15 11.89c0 1.75.46 3.45 1.32 4.95L2 22l5.31-1.39a9.86 9.86 0 0 0 4.73 1.2h.01c5.46 0 9.89-4.43 9.89-9.89C22 6.43 17.5 2 12.04 2zm5.72 14.05c-.24.68-1.4 1.25-1.94 1.33-.5.07-1.13.1-1.82-.11-.42-.13-.95-.31-1.64-.6-2.89-1.25-4.77-4.16-4.92-4.35-.14-.2-1.18-1.57-1.18-3 0-1.42.75-2.12 1.01-2.41.27-.29.58-.36.77-.36h.55c.18 0 .42-.07.65.5.24.58.82 2 .89 2.14.07.14.12.31.02.5-.1.2-.15.31-.3.48-.14.16-.3.36-.43.49-.14.14-.29.29-.12.56.16.27.73 1.2 1.57 1.95 1.08.96 1.99 1.26 2.26 1.4.27.14.43.12.59-.07.16-.2.68-.79.86-1.06.18-.27.36-.22.61-.13.24.09 1.54.73 1.8.86.27.13.44.2.51.31.07.11.07.64-.17 1.32z"/>
          </svg>
        </a>
      </div>
    </section>
  </ng-container>
</div>
